module.exports = __webpack_public_path__ + "img/stamp-off.33f91ec4.svg";